import { aTrack } from "../primitives/a-track";
class WhitelistEvents {
    constructor() {
        this.options = {
            origin: 'whitelist',
        };
    }
    added_contact(contactType, contact) {
        aTrack('added_contact', Object.assign({ contactType,
            contact }, this.options));
    }
    claimed_whitelist_offer() {
        aTrack('claimed_whitelist_offer', Object.assign({}, this.options));
    }
    clicked_join_waitlist() {
        aTrack('clicked_join_waitlist', Object.assign({}, this.options));
    }
    ignored_add_contact() {
        aTrack('ignored_add_contact', Object.assign({}, this.options));
    }
    ignored_waitlist_offer() {
        aTrack('ignored_waitlist_offer', Object.assign({}, this.options));
    }
    ignored_whitelist_offer() {
        aTrack('ignored_whitelist_offer', Object.assign({}, this.options));
    }
    received_zealy_xp_bonus() {
        aTrack('received_zealy_xp_bonus', Object.assign({}, this.options));
    }
    registered_zealy() {
        aTrack('registered_zealy', Object.assign({}, this.options));
    }
    clickedFAQ() {
        aTrack('clicked_faq', Object.assign({}, this.options));
    }
}
export function createWhitelistEvent() {
    return new WhitelistEvents();
}
//# sourceMappingURL=whitelist-events.js.map